import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ApiConnect from "../../../../Utils/ApiConnect";
import { connect } from "react-redux";
import {
  CustomerPromo,
  CustomerDiscountGroup,
} from "../../../../redux/actions/Modules.Action";
import ReactDatatable from "@ashvin27/react-datatable";
import { toast } from "react-toastify";
import DeletePop from "../../../Components/DeletePop";
class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      triggerModal: false,
      selectedId: false,
      formError: false,
      name: "",
      group: "",
      valid: "",
      code: "",
    };
    this.columns = [
      {
        key: "name",
        text: "Promo Title",
      },
      {
        key: "code",
        text: "Promo Code",
      },
      {
        key: "limit",
        text: "Promo Limit",
      },
      {
        key: "total_clamed",
        text: "Total Clamed",
      },
      {
        key: "last_used",
        text: "Last Update",
      },
      {
        key: "last_invoice",
        text: "Last Invoice",
      },
      {
        key: "valid",
        text: "Valid till",
      },
      {
        key: "action",
        text: "Action",
        className: "table-actions",
        width: 150,
        sortable: false,
        align: "center",
        cell: (record) => {
          return (
            <React.Fragment>
              <button
                className="table-action btn btn-square btn-pure hover-danger"
                onClick={() =>
                  this.setState({ selectedId: record.code, triggerModal: true })
                }
              >
                <span className="material-icons-outlined">delete</span>
              </button>
            </React.Fragment>
          );
        },
      },
    ];
    this.config = {
      key_column: "id",
      page_size: 30,
      length_menu: [30, 60, 90],
      show_filter: true,
      show_pagination: true,
      button: {
        // excel: true,
        // print: true
      },
      language: {
        loading_text: "Please be patient while data loads...",
      },
    };
  }
  componentDidMount() {
    this.fetchPromo();
    this.fetchDiscount();
  }
  fetchPromo = () => {
    ApiConnect.get("/Members/Information/PromoCode")
      .then((response) => {
        this.props.CustomerPromo(response.data);
      })
      .catch((error) => console.log(error));
  };
  fetchDiscount = () => {
    ApiConnect.get("/Members/Information/DiscountGroup")
      .then((response) => {
        this.props.CustomerDiscountGroup(response.data);
      })
      .catch((error) => console.log(error));
  };
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ btnDisable: true });
    var Fdata = new FormData();
    Fdata.append("name", this.state.name);
    Fdata.append("discount", this.state.group);
    Fdata.append("valid", this.state.valid);
    Fdata.append("code", this.state.code);
    ApiConnect({
      method: "post",
      url: "/Members/Information/NewPromo",
      data: Fdata,
    })
      .then((response) => {
        this.setState({ btnDisable: false });
        if (response.data.status === 406) {
          this.setState({ formError: response.data.message });
        } else if (response.data.status === 201) {
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            draggableDirection: "y",
          });
          this.setState({
            showModal: false,
            triggerModal: false,
            selectedId: false,
            formError: false,
            name: "",
            group: "",
            valid: "",
            code: "",
          });
          this.fetchPromos();
        } else if (response.data.status) {
          this.setState({ formError: response.data.message });
        }
      })
      .catch((error) => console.log(error));
  };
  SettriggerModal = () => {
    this.setState({ selectedId: false, triggerModal: false });
  };
  render() {
    return (
      <div className="col-md-12 col-xl-12">
        <div className="card">
          <header className="header no-border">
            <div className="header-info">
              <div className="left">
                <h2 className="header-title">
                  <strong>Promo Codes</strong>
                </h2>
              </div>
              <div className="right gap-items-2">
                <button
                  className="btn btn-primary  btn-float btn-round"
                  onClick={() => {
                    this.setState({ showModal: true });
                  }}
                >
                  <span className="material-icons-outlined">add</span>
                </button>
              </div>
            </div>
            <div className="header-action"></div>
          </header>
          <div className="card-body">
            <div className="dataTables_wrapper">
              <ReactDatatable
                className="table table-separated"
                tHeadClassName="custom-header-style"
                config={this.config}
                records={this.props.Promo}
                columns={this.columns}
              />
            </div>
          </div>
          <Modal
            show={this.state.showModal}
            className="modal-center"
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Dialog>
              <Modal.Header>
                <h5 className="modal-title">New Promo</h5>
                <button
                  type="button"
                  className="btn"
                  onClick={() => this.setState({ showModal: false })}
                >
                  <span>×</span>
                </button>
              </Modal.Header>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <Modal.Body>
                  <p className="text-danger">{this.state.formError}</p>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Promo Title</label>
                      <input
                        type="text"
                        name="name"
                        className="form-control"
                        onChange={(e) => this.handleChange(e)}
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Discount Group</label>
                      <select
                        className="form-control"
                        name="group"
                        onChange={(e) => this.handleChange(e)}
                      >
                        <option>Select Group</option>
                        {this.props.Discount.map((group, index) => (
                          <option value={group.id} key={`${group}${index}`}>
                            {group.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row form-group">
                    <div className="col">
                      <label className="form-label">Code</label>
                      <input
                        onChange={(e) => this.handleChange(e)}
                        type="text"
                        className="form-control"
                        name="code"
                        required="required"
                      />
                    </div>
                    <div className="col">
                      <label className="form-label">Valid till</label>
                      <label className="col-12">
                        <input
                          onChange={(e) => this.handleChange(e)}
                          type="date"
                          className="form-control"
                          name="valid"
                          required="required"
                        />
                      </label>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button type="submit" className="btn btn-success">
                    Create
                  </button>
                </Modal.Footer>
              </form>
            </Modal.Dialog>
          </Modal>
          <DeletePop
            trigger={this.state.triggerModal}
            delUrl={`/Members/Information/DeletePromo?id=${this.state.selectedId}`}
            hideTrigger={this.SettriggerModal}
            fallAction={this.fetchPromo}
          />
        </div>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    Promo: state.Customer.Promo,
    Discount: state.Customer.Discount,
  }),
  { CustomerPromo, CustomerDiscountGroup }
)(index);
